import styled from 'styled-components'

export const PlainText = styled('div')`
  font-family: var(--regular);
  font-size: 1em;
  color: var(--text);
`
